export const isNegative = (num: number) => {
    if (Math.sign(num) === -1) {
        return true;
    }

    return false;
};

export const formatNumber = (number: number | string) => {
    // Вставляет пробелы на каждые 000
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const changeNumberField = (
    value: string,
    onChange: (value: string) => void,
    pattern: RegExp = /^\d*$/,
) => {
    const trimValue = value.trim();
    if (!pattern.test(trimValue) && value !== '') return;

    onChange(trimValue);

    return trimValue;
};

export const formateStringAsNumber = ({
    value,
    isInteger = true,
    onlyPositive = true,
}: {
    value: string;
    isInteger?: boolean;
    onlyPositive?: boolean;
}) => {
    // Удаляем все кроме цифр, минуса, точек и запятых
    let result = value.replace(/[^\d,.-]/g, '').replace(',', '.');

    // Оставляем только первый минус (если он есть)
    result = result.replace(/-/g, (_match, offset) => (offset === 0 ? '-' : ''));

    // Заменяем все запятые и точки после первой на пустую строку
    let hasDecimal = false;
    result = result.replace(/[,.]/g, (match) => {
        if (!hasDecimal) {
            hasDecimal = true;
            return match; // Оставляем первый разделитель
        }
        return ''; // Удаляем последующие разделители
    });

    if (isInteger) {
        result = result.replace('.', '').replace(',', '');
    }
    if (onlyPositive) {
        result = result.replace('-', '');
    }
    return result;
};
export const roundToTenths = (value: number): number => Math.round(value * 10) / 10;
export const roundToHundredths = (value: number | string): number =>
    Math.round(Number(value) * 100) / 100;
